import {useQuery, UseQueryResult} from '@tanstack/react-query';

import {objectToUrlParameters} from '../../../util/url';

import {getLpsAverageRatingUrl, loadLpsAverageRating, loadLpsBenchmarks} from './dashboard-lps-api';
import {DashboardLpsBenchmarksResponseType, DashboardLpsResponseType} from './dashboard-lps-type';

type PropsType = {
    startDate: string;
    endDate: string;
};

export function useLpsAverageRating({startDate, endDate}: PropsType): UseQueryResult<DashboardLpsResponseType> {
    return useQuery(
        [getLpsAverageRatingUrl(objectToUrlParameters({startDate, endDate}))],
        () =>
            loadLpsAverageRating({
                startDate,
                endDate,
            }),
        {
            retry: 2,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchInterval: false,
        }
    );
}

export function useLpsBenchmarks(): UseQueryResult<DashboardLpsBenchmarksResponseType> {
    return useQuery(['loadLpsBenchmarks'], () => loadLpsBenchmarks());
}
